import React, { useState, useRef } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
  Button,
  Pagination,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { format } from "date-fns";
import BOPPListModal from "./BoPPListModal";
import ModalBox from "../Core/ModalBox/ModalBox";

const BOPPList = ({ logsList, currentPage, setCurrentPage }) => {
  const ref = useRef();
  const [expandedItems, setExpandedItems] = useState({});
  const [docId, setDocId] = useState(null);

  const handleChange = (panel) => (_, isExpanded) => {
    setExpandedItems((prevExpandedItems) => ({
      ...prevExpandedItems,
      [panel]: isExpanded,
    }));
  };

  const handlePageChange = (_, newPage) => {
    setCurrentPage(newPage);
  };

  const handleOpenModal = (id) => {
    setDocId(id);
    ref?.current?.openModal();
  };

  const lines = ["Line 1", "Line 2", "Line 3", "Line 4", "Line 5", "Line 6"];

  const checklistLogs = lines
    .map((line) =>
      logsList
        ?.filter((item) => item?.organization === line)
        .map((item) => ({ ...item, line }))
    )
    .flat();


  const paginatedLogs = checklistLogs?.slice(
    (currentPage - 1) * 10,
    currentPage * 10
  );

  return (
    <>
      <Box>
        {paginatedLogs?.map((item, index) => {
          const showLineHeader =
            index === 0 || paginatedLogs[index - 1]?.line !== item.line;

          return (
            <Box key={item?._id}>
              {showLineHeader && (
                <Typography variant="h5" sx={{ mb: 2, mt: 2 }}>
                  {item?.line}
                </Typography>
              )}

              <Accordion
                expanded={expandedItems[`panel${item?._id}`]}
                onChange={handleChange(`panel${item?._id}`)}
                sx={{ marginBottom: 2 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${item?._id}-content`}
                  id={`panel${item?._id}-header`}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    width="100%"
                  >
                    <Typography variant="h6">
                      Checklist -{" "}
                      <span>
                        {item?.dateObj?.date
                          ? format(
                              new Date(item?.dateObj?.date),
                              "EEE dd, yyyy"
                            )
                          : ""}
                      </span>
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Box sx={{ marginLeft: 2 }}>
                    <Typography variant="body1">
                      Shift Incharge:{" "}
                      {item?.personnelObj?.shiftIncharge || "N/A"}
                    </Typography>
                    <Typography variant="body1" mt={1}>
                      Operator: {item?.personnelObj?.operator || "N/A"}
                    </Typography>
                    <Box mt={1}>
                      <Button
                        size="small"
                        variant="contained"
                        sx={{ cursor: "pointer", marginBottom: "4px" }}
                        onClick={() => handleOpenModal(item?._id)}
                      >
                        View details
                      </Button>
                    </Box>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Box>
          );
        })}
      </Box>
      <Box display="flex" justifyContent="center" mt={2}>
        <Pagination
          count={Math.ceil(checklistLogs?.length / 10)}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
      <ModalBox ref={ref} size="lg" title="">
        <BOPPListModal docId={docId} />
      </ModalBox>
    </>
  );
};

export default BOPPList;
